import { isTypeNavigationCard, TypeNavigationCardSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulNavigationCard = ({
  entry,
}: {
  entry: Entry<TypeNavigationCardSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeNavigationCard(entry)) {
    return null;
  }

  return (
    <a
      className='min-w-0 bg-white sm:min-h-25 shadow rounded-sm grow-0 shrink p-5 transition duration-200 ease-in-out hover:-translate-y-2 hover:shadow-lg text-left'
      href={entry.fields.url}
      target={entry.fields.openInNewTab ? '_blank' : '_self'}
    >
      <h3 className='mb-3 text-left text-xl leading-6 font-semibold items-center [&>svg]:shrink-0 [&>svg]:inline [&>svg]:mr-2'>
        {entry.fields.icon && (
          <>
            <span className={`fal fa-${entry.fields.icon} text-2xl`} />
            &nbsp;
          </>
        )}
        {/*{icon && icon !== 'linked-in' && <Icon type={icon} size='24' /> */}
        {/* The LinkedIn icon is odd in that you need to render a larger viewbox than expected */}
        {/*{icon === 'linked-in' && <Icon type={icon} size='24' viewbox='0 0 32 32' />}*/}
        <span>{entry.fields.header}</span>
      </h3>
      {entry.fields.description}
    </a>
  );
};

export default ContentfulNavigationCard;
